import type { FC } from 'react'
import type { InlineDropdownItemProps } from './types'
import Check from '@sylveraio/untitled-ui-icons-react/build/esm/Check'
import clsx from 'clsx'
import { Typography } from '../../Typography'

export const InlineDropdownItem: FC<InlineDropdownItemProps> = ({
  label,
  selected,
  ...rest
}) => {
  return (
    <li
      className="flex h-10 cursor-pointer items-center space-x-2 bg-high px-3 hover:bg-high-hover"
      aria-selected={selected}
      role="option"
      tabIndex={0}
      {...rest}
    >
      <Check
        className={clsx('w-4 h-4 shrink-0', {
          invisible: !selected,
        })}
      />
      <Typography weight="regular" size="sm" className="whitespace-nowrap">
        {label}
      </Typography>
    </li>
  )
}
